import React, { createContext, useContext } from "react";

const HelpNavigationContext = createContext(null);

export const HelpNavigationProvider = ({ location, navigate, children }) => (
  <HelpNavigationContext.Provider value={{ location, navigate }}>
    {children}
  </HelpNavigationContext.Provider>
);

export const useHelpLocation = () => {
  const context = useContext(HelpNavigationContext);
  if (!context) throw new Error("Help navigation is only available inside the help modal.");
  return context.location;
};

export const useHelpNavigate = () => {
  const context = useContext(HelpNavigationContext);
  if (!context) throw new Error("Help navigation is only available inside the help modal.");
  return context.navigate;
};

export const HelpLink = ({ to, state, onClick, ...props }) => {
  const context = useContext(HelpNavigationContext);
  if (!context) throw new Error("Help links are only available inside the help modal.");

  const href = typeof to === "string" ? to : to?.pathname || "/ajuda";
  const handleClick = (event) => {
    onClick?.(event);
    if (
      event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
    ) return;

    event.preventDefault();
    context.navigate(to, state);
  };

  return <a {...props} href={href} onClick={handleClick} />;
};
